module.exports = __webpack_public_path__ + "static/aikido-6a6627a464aabaa73414c30678ee45be.svg";